///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ResetIcon = ({
  height,
  fill,
  title = messages.reset.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="reset-icon"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="reset-icon">{title}</title>
    <path
      fill={fill}
      d="M8.67 2a6 6 0 00-6 6h-2l2.59 2.6.05.09L6 8H4a4.66 4.66 0 111.37 3.3l-.94.94A6 6 0 108.67 2zM8 5.33v3.34l2.85 1.69.48-.8L9 8.15V5.34H8z"
    />
  </svg>
);

export default ResetIcon;
